/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeRewardNotificationAction } from './ChallengeRewardNotificationAction';
import {
    ChallengeRewardNotificationActionFromJSON,
    ChallengeRewardNotificationActionFromJSONTyped,
    ChallengeRewardNotificationActionToJSON,
} from './ChallengeRewardNotificationAction';

/**
 * 
 * @export
 * @interface ChallengeRewardNotification
 */
export interface ChallengeRewardNotification {
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeRewardNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChallengeRewardNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ChallengeRewardNotificationAction>}
     * @memberof ChallengeRewardNotification
     */
    actions: Array<ChallengeRewardNotificationAction>;
}

/**
 * Check if a given object implements the ChallengeRewardNotification interface.
 */
export function instanceOfChallengeRewardNotification(value: object): value is ChallengeRewardNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ChallengeRewardNotificationFromJSON(json: any): ChallengeRewardNotification {
    return ChallengeRewardNotificationFromJSONTyped(json, false);
}

export function ChallengeRewardNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRewardNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ChallengeRewardNotificationActionFromJSON)),
    };
}

export function ChallengeRewardNotificationToJSON(value?: ChallengeRewardNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ChallengeRewardNotificationActionToJSON)),
    };
}

